import DataCell from "@/components/DataCell";
import Map, { Marker } from "@/components/map/Map";
import { AnonymousUser, User } from "@/types";
import { WhatsappIcon, Location01Icon, Home01Icon, RoadLocation01Icon, UserIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Stack, Paper, Avatar, Typography, Divider, useTheme, Grid2 as Grid } from "@mui/material";

interface Props {
  client: User | AnonymousUser;
}

const ViewCustomerTab = ({ client }: Props) => {
  const { palette } = useTheme();

  return (
    <Grid container spacing={2} alignContent="flex-start" height="100%">
      <Grid size={{ xs: 12, sm: 4 }}>
        <Stack spacing={2}>
          <Paper
            sx={{
              p: 2,
            }}
          >
            <Stack justifyContent={"center"} alignItems={"center"} spacing={2} paddingTop={2}>
              {client?.image ? (
                <Avatar src={client.image} alt="Foto de perfil del cliente" sx={{ width: 100, height: 100 }} />
              ) : (
                <Avatar
                  sx={{
                    width: 100,
                    height: 100,
                    backgroundColor: palette.primary.light,
                  }}
                >
                  <HugeiconsIcon icon={UserIcon} color={palette.primary.main} size={50} />
                </Avatar>
              )}
              {client?.name ? (
                <Typography variant="h4" sx={{ textAlign: "center" }}>
                  {client.name} {client?.lastname ?? ""}
                </Typography>
              ) : null}
              <Divider />
            </Stack>
          </Paper>
          <Paper
            sx={{
              p: 2,
            }}
          >
            <Stack direction={"row"} spacing={2} alignItems={"center"}>
              <HugeiconsIcon icon={WhatsappIcon} color={palette.primary.main} size={22} />
              <DataCell vertical label="Whatsapp" value={String(client?.phone ? client.phone : "-")} />
            </Stack>
          </Paper>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, sm: 8 }}>
        <Paper
          sx={{
            width: "100%",
          }}
        >
          <Stack spacing={2} pt={2}>
            {/* <Stack direction={"row"} spacing={2} alignItems={"center"} px={2} pt={2}>
              <HugeiconsIcon icon={Location01Icon} color={palette.primary.main} />
              <DataCell vertical label="Barrio" value={client?.locations?.[0]?.neighborhood} />
            </Stack> */}
            <Stack direction={"row"} spacing={2} alignItems={"center"} px={2}>
              <HugeiconsIcon icon={Home01Icon} color={palette.primary.main} />
              <DataCell vertical label="No. de Casa" value={client?.locations?.[0]?.house} />
            </Stack>
            <Stack direction={"row"} spacing={2} alignItems={"center"} px={2}>
              <HugeiconsIcon icon={RoadLocation01Icon} color={palette.primary.main} />
              <DataCell vertical label="Dirección / Cómo llegar:" value={client?.locations?.[0]?.address} />
            </Stack>
            {client?.locations ? (<Map height={"370px"} type="roadmap">
              <Marker lat={client?.locations?.[0]?.latitude ?? ""} lng={client?.locations?.[0]?.longitude ?? ""} />
            </Map>) : null}
          </Stack>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default ViewCustomerTab;
